import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { useMediaSettingsModal } from "../MediaSettingsModal";

const i18nRoot = "media_player.settings.overlay";

interface MediaSettingsOverlayProps {
  signedId: string;
}

export const MediaSettingsOverlay = ({
  signedId,
}: MediaSettingsOverlayProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const isInsideMobileWebview = Boolean(window.webview?.isInsideMobileWebview);
  const mediaSettingsModal = useMediaSettingsModal();

  if (!isAdmin || isInsideMobileWebview) {
    return null;
  }

  const handleOpenSettings = () => {
    void mediaSettingsModal.show({ signedId });
  };

  return (
    <div className="invisible absolute right-4 top-4 z-10 flex group-hover:visible">
      <TippyV2
        content={t(`${i18nRoot}.customize_video`)}
        arrow={false}
        interactive={false}
      >
        <button
          type="button"
          onClick={handleOpenSettings}
          className="bg-primary text-dark border-tertiary hover:bg-secondary flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border"
        >
          <Icon type="20-settings-slider" size={20} />
        </button>
      </TippyV2>
    </div>
  );
};
